/*
 * UI-skaalaus (Sessio 21.5): portaittainen koko-UI-zoom luettavuuteen 4K-naytoilla.
 *
 * Taso kerrotaan juurifonttiin (globals.css: html { font-size: calc(16px * var(--ui-scale)) }).
 * Koska typografia (theme.css --text-*), Tailwind-spacing ja layout-mitat ovat rem-pohjaisia,
 * yksi kerroin skaalaa koko UI:n suhteessa — nakyma zoomaa, ei hajoa.
 *
 * Valinta persistoidaan useUIStore:een (localStorage: luviamo-ui-prefs) ja sovelletaan
 * juureen ScaleSwitcherista (runtime) + main.tsx:ssa ennen ensimmaista maalausta (FOUC-esto).
 */

/** Portaat: 100 % / 110 % / 125 % / 140 %. Jarjestys = nappien jarjestys Headerissa. */
export const UI_SCALE_LEVELS = [1, 1.1, 1.25, 1.4] as const;

export type UiScale = (typeof UI_SCALE_LEVELS)[number];

/** Oletustaso (100 %) — identtinen entiseen px-typografiaan. */
export const DEFAULT_UI_SCALE: UiScale = 1;

/** Onko arvo sallittu skaalataso (esim. persistoidun arvon tunnistukseen UI:ssa). */
export function isUiScale(value: unknown): value is UiScale {
  return typeof value === 'number' && (UI_SCALE_LEVELS as readonly number[]).includes(value);
}

/**
 * Aseta skaala juureen (html-elementti). Kutsutaan ScaleSwitcherista valinnan yhteydessa
 * seka main.tsx-initissa. No-op SSR/testiymparistossa jossa document puuttuu.
 */
export function applyUiScale(scale: number): void {
  if (typeof document === 'undefined') return;
  document.documentElement.style.setProperty('--ui-scale', String(scale));
}
